import React, { useState, useEffect } from 'react';
import NavBar from './NavBar/NavBar';
import ProductSlide from './HomeComponent/ProductSlide';
import About from './AboutComponent/About';
import Product from './ProductComponent/Product';
import FAQ from './FAQComponent/FAQ';
import Footer from './Footer/Footer';
import Store from './Store/Store';
import Contact from './Contact/Contact';
import FollowNavigator from './FollowNavigator';

const MainPage = () => {
  const [productPosition, setProductPosition] = useState('');
  const [navScroll, setNavScroll] = useState(false);

  useEffect(() => {
    document.addEventListener('scroll', () => {
      if (window.scrollY > 80) {
        setNavScroll(false);
      } else {
        setNavScroll(true);
      }
    });
  });

  return (
    <>
      {!navScroll && <FollowNavigator />}
      <NavBar productPosition={productPosition} />
      <ProductSlide />
      <About setProductPosition={setProductPosition} />
      <Product setProductPosition={setProductPosition} />
      <FAQ setProductPosition={setProductPosition} />
      <Store setProductPosition={setProductPosition} />
      <Contact setProductPosition={setProductPosition} />
      {/* <div
        id="fifth"
        style={{
          width: '100%',
          height: '800px',
          border: '1px solid red',
          paddingTop: '62px',
        }}
      >
        4
      </div> */}
      {/* <div
        id="sixth"
        style={{
          width: '100%',
          height: '800px',
          border: '1px solid red',
          paddingTop: '62px',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <div className="test" {...animatedItem1}>
          left
        </div>
        <div className="test" {...animatedItem2}>
          down
        </div>
        <div className="test" {...animatedItem3}>
          right
        </div>
      </div> */}
      <Footer />
    </>
  );
};

export default MainPage;
